<template>
  <div>
    <div v-if="componente">
      <progresso-fidelidade :pontos="saldoFidelidade - pontosSacola" :progresso="progresso" componente="true"/>
    </div>
    <div v-else>
      <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
      <div v-if="!load">
        <div id="beneficios">
          <div class="mb-3">
            <progresso-fidelidade :pontos="saldoFidelidade - pontosSacola" :progresso="progresso"/>
          </div>
          <div class="mb-4" style="padding-top: 6px">
            <div class="row no-gutters text-center" style="margin-bottom: 32px" v-if="filtro_resgate">
              <div class="col pr-1">
                <a href="javascript:" class="btn btn-outline-primary btn-block" :class="{'active': tipo_resgate === 1}" @click="tipo_resgate = 1">Resgate no Delivery</a>
              </div>
              <div class="col pr-1">
                <a href="javascript:" class="btn btn-outline-primary btn-block" :class="{'active': tipo_resgate === 2}" @click="tipo_resgate = 2">Resgate na Loja</a>
              </div>
            </div>

            <div class="mb-3" v-if="produtos_delivery.length && tipo_resgate === 1">
              <h5 class="text-center font-weight-normal mb-3">Produtos do Clube</h5>
              <div class="row no-gutters">
                <div class="col-6 col-lg-4 col-xl-3 p-1" v-for="l in produtos_delivery" :key="l.id_beneficio">
                  <a href="javascript:" class="card card-produto" @click="openBeneficio(l)">
                    <img :src="l.url_imagem || l.img_produto || img_empresa || img_default" aria-hidden="true">
                    <div class="text-dark ">
                      <div class="m-0 limite-1">{{l.titulo}}</div>
                      <h6 class="font-weight-bold text-primary">{{l.pontos}} pontos</h6>
                    </div>
                    <div class="px-2">
                      <button class="btn btn-outline-primary btn-block">Resgatar</button>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div class="mb-3" v-if="produtos_loja.length && tipo_resgate === 2">
              <h5 class="text-center font-weight-normal mb-3">Produtos do Clube</h5>
              <div class="row no-gutters">
                <div class="col-6 col-lg-4 col-xl-3 p-1" v-for="l in produtos_loja" :key="l.id_beneficio">
                  <a href="javascript:" class="card card-produto" @click="openBeneficio(l)">
                    <img :src="l.url_imagem || l.img_produto || img_empresa || img_default" aria-hidden="true">
                    <div class="text-dark ">
                      <div class="m-0 limite-1">{{l.titulo}}</div>
                      <h6 class="font-weight-bold text-primary">{{l.pontos}} pontos</h6>
                    </div>
                    <div class="px-2">
                      <button class="btn btn-outline-primary btn-block">Resgatar</button>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div class="mb-3" v-if="cupons.length && tipo_resgate === 1">
              <h5 class="text-center font-weight-normal mb-3">Cupons do Clube</h5>
              <div class="row no-gutters">
                <div class="col-6 col-lg-4 col-xl-3 p-1" v-for="l in cupons" :key="l.id_beneficio">
                  <a href="javascript:" class="card card-produto" @click="openBeneficio(l)">
                    <img :src="l.url_imagem || l.img_produto || img_empresa || img_default" aria-hidden="true">
                    <div class="text-dark ">
                      <div class="m-0 limite-1">{{l.titulo}}</div>
                      <h6 class="font-weight-bold text-primary">{{l.pontos}} pontos</h6>
                    </div>
                    <div class="px-2">
                      <button class="btn btn-outline-primary btn-block">Resgatar</button>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div v-if="brindes.length && tipo_resgate === 2">
              <h5 class="text-center font-weight-normal mb-3">Brindes do Clube</h5>
              <div class="row no-gutters">
                <div class="col-6 col-lg-4 col-xl-3 p-1" v-for="l in brindes" :key="l.id_beneficio">
                  <a href="javascript:" class="card card-produto" @click="openBeneficio(l)">
                    <img :src="l.url_imagem || l.img_produto || img_empresa || img_default" aria-hidden="true">
                    <div class="text-dark ">
                      <div class="m-0 limite-1">{{l.titulo}}</div>
                      <h6 class="font-weight-bold text-primary">{{l.pontos}} pontos</h6>
                    </div>
                    <div class="px-2">
                      <button class="btn btn-outline-primary btn-block">Resgatar</button>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <h5 class="font-weight-normal text-center" style="margin: 32px 0 22px">
            Clube de Vantagens <b class="d-block d-md-inline-block">{{empresa.nome_fantasia}}</b>
          </h5>
          <div id="regras" class="card text-center como-funciona mt-4">
            <h6 class="font-weight-normal mb-4 pb-2">Veja como é fácil {{token ? 'utilizar' : 'participar'}}</h6>
            <div class="row no-gutters">
              <div class="col-md-6 como-funciona-item">
                <div class="px-4">
                  <icon name="pontos" class="text-primary" size="32"></icon>
                  <h5 class="mt-3 mb-2">Acumule pontos</h5>
                  <div>
                    <span v-if="empresa.fidelidade.tipo_fidelidade === '1'">Ganhe 1 ponto a cada pedido</span>
                    <span v-else-if="empresa.fidelidade.tipo_fidelidade === '2'">Pontue comprando itens* promocionais</span>
                    <span v-else>Ganhe 1 ponto a cada {{empresa.fidelidade.valor_ponto | valor}} em compras</span> em nosso site ou app.
                    <span v-if="empresa.fidelidade.validade_pontos < 10000">Cada ponto tem o tempo de expiração de {{empresa.fidelidade.validade_pontos}} dias.</span>
                    <span v-else>Pode ficar tranquilo, seus pontos não vão expirar.</span>
                  </div>
                  <div class="small d-md-none mt-2" v-if="empresa.fidelidade.tipo_fidelidade === '2'">
                    *Confira os itens participantes dessa promoção
                  </div>
                </div>
              </div>
              <div class="col-md-6 como-funciona-item">
                <div class="px-4">
                  <icon name="cupom" class="text-primary" size="34"></icon>
                  <h5 class="mt-3 mb-2">Resgate prêmios</h5>
                  <div>
                    Troque seus pontos por benefícios que podem ser resgatados no site/app ou consumidos em nossa loja.
                  </div>
                </div>
              </div>
            </div>
            <div class="row no-gutters justify-content-center pt-2 pt-md-0 mt-4" v-if="!token">
              <div class="col-sm-5 col-md-4 col-xl-3 mb-3 mb-sm-0 pr-1">
                <router-link :to="url + '/perfil'" class="btn btn-primary btn-block btn-sm">Quero me cadastrar</router-link>
              </div>
              <div class="col-sm-5 col-md-4 col-xl-3 pl-1">
                <router-link :to="url + '/perfil'" class="btn btn-outline-primary btn-block btn-sm">Já sou membro</router-link>
              </div>
            </div>
            <div class="mt-4 small d-none d-md-block" v-if="empresa.fidelidade.tipo_fidelidade === '2'">
              *Confira os itens participantes dessa promoção
            </div>
          </div>

          <div class="small" style="margin-top: 42px">
            <h5>Regras do Clube de Vantagens</h5>
            <p class="mb-2">
              *O valor mínimo de uma compra para pontuar é de {{empresa.fidelidade.valor_ponto | valor}} e a taxa de entrega não está inclusa no cálculo de pontos.
              Confira se o item que você está comprando está participando desta promoção.
            </p>
            <p class="mb-0" v-if="empresa.fidelidade.descricao">{{empresa.fidelidade.descricao}}</p>
          </div>
        </div>
      </div>
    </div>
    <beneficio-fidelidade :saldo="saldoFidelidade - pontosSacola" @atualizar="iniciar" @fechar="$emit('openSacola')" ref="beneficio" :tipo_resgate="tipo_resgate"/>
  </div>
</template>

<script>
  import Loading from '../components/Loading'
  import BottomBar from '../components/BottomBar';
  import AdsLeCard from "../components/AdsLeCard";
  import CardInfo from "../components/CardInfo";
  import Icon from "../components/Icon";
  import BeneficioFidelidade from "../components/BeneficioFidelidade";
  import ProgressoFidelidade from "../components/ProgressoFidelidade";

  export default {
    name: 'Fidelidade',
    components: {ProgressoFidelidade, BeneficioFidelidade, Icon, CardInfo, AdsLeCard, Loading, BottomBar},
    props: ['componente'],
    data() {
      return {
        load: true,
        tipos: [],
        token: localStorage.getItem('token'),
        progresso: 0,
        cupons: [],
        produtos_loja: [],
        produtos_delivery: [],
        brindes: [],
        tipo_resgate: 1,
        filtro_resgate: false
      }
    },

    methods: {
      buscarDados() {
        this.load = true;
        this.$http.get(this.$store.state.base_url + 'fidelidade')
          .then(response => {
            if (response.data && response.data.beneficios) {
              this.$store.state.beneficios = response.data.beneficios;
              this.preencherFidelidade()
            }

          }, res => {
            this.load = false;
          });
      },

      preencherFidelidade() {
        if (this.beneficios.length) {
          this.cupons = this.beneficios.filter(b => b.tipo_beneficio === '1');
          this.brindes = this.beneficios.filter(b => b.tipo_beneficio === '3');
          this.produtos_delivery = this.beneficios.filter(b => b.tipo_beneficio === '2' && b.tipo_resgate !== '2');
          this.produtos_loja = this.beneficios.filter(b => b.tipo_beneficio === '2' && b.tipo_resgate !== '1');
        }

        this.filtro_resgate = (this.cupons.length && this.brindes.length) || (this.produtos_loja.length && this.produtos_delivery.length);

        if (!this.filtro_resgate && this.produtos_loja.length) {
          this.tipo_resgate = 2;
        }

        this.load = false;
        this.$nextTick(() => {
          setTimeout(() => {
            window.scrollTo(0,0);
          }, 100);

          if (!this.componente && this.$route.hash === '#regras') {
            this.$helpers.scrollTo('regras')
          }
        })
      },

      buscarPontos() {
        if (this.saldoFidelidade) {
          this.getProgresso();
          return;
        }

        this.$http.get(this.$store.state.base_url + this.token + '/meus-pontos')
          .then(response => {
            const data = response.data ? response.data.saldo : 0;
            this.$store.state.saldoFidelidade = (!isNaN(data) ? parseInt(data) : 0);
            this.getProgresso();

          }, res => {
            this.load = false;
          });
      },

      getProgresso() {
        setTimeout(() => {
          const saldo = this.saldoFidelidade - this.pontosSacola;
          const percent = saldo > 120 ? 120 : saldo;
          this.progresso = 100 * (percent/120);
        }, 600);
      },

      openBeneficio(b) {
        if (b) {
          this.$emit('openBeneficio', b);
        }
      },

      iniciar() {
        if (!this.componente && !this.beneficios.length) {
          this.buscarDados();

        } else {
          this.preencherFidelidade()
        }

        if (this.token) {
          this.buscarPontos()
        }
      }
    },

    mounted() {
      if (this.empresa.fidelidade) {
        this.iniciar();
      }
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      dataUser() {
        return this.$store.state.dataUser
      },

      url() {
        return this.$store.state.url
      },

      beneficios() {
        return this.$store.state.beneficios;
      },

      saldoFidelidade() {
        return this.$store.state.saldoFidelidade;
      },

      pontosSacola() {
        return this.$store.state.pontosSacola;
      },

      img_empresa() {
        return this.$store.state.empresa.url_imagem
      }
    },

    filters: {
      tipo(t) {
        switch (t) {
          case '1': return  'Cupom';
          case '2': return  'Produto';
          case '3': return  'Brinde';
        }
      }
    },

    beforeRouteLeave(to, from, next) {
      if (['MeusVouchers'].includes(to.meta.page)) {
        next();

      } else if (this.$refs.beneficio && this.$refs.beneficio.aberto) {
        this.$emit('closeBeneficio');
        next(false);

      } else {
        next()
      }
    }
  }
</script>
<style scoped>
  .btn.btn-block {
    min-height: 0;
    padding: 6px 0;
  }

  .como-funciona {
    box-shadow: var(--shadow);
    margin-bottom: 32px;
    padding: 32px 15px;
  }

  .como-funciona-item:first-child {
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 26px;
    padding-bottom: 26px;
  }

  .btn-outline-primary.active {
    background-color: var(--lecard-primary)!important;
    color: #ffffff!important;
  }

  @media (min-width: 768px) {
    .como-funciona {
      padding: 32px 0 22px;
    }

    .como-funciona-item:first-child {
      border-right: 1px solid #dee2e6;
      border-bottom: none;
      margin-bottom: 0;
    }
  }
</style>
